module.exports = __webpack_public_path__ + "static/media/user.65b414e5.svg";